export default __webpack_public_path__ + "static/media/image00001.e5bae286.jpeg";